import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SimpleLayoutComponent } from './@theme/layouts/simple-layout/simple.layout';

export const routes: Routes = [ 
  {
    path: '',
    loadChildren: () => import('./main/main.module')
      .then(m => m.MainModule),
  },
  {
    path: 'user',
    loadChildren: () => import('./main/user/user.module')
      .then(m => m.UserModule),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
